<template>
	<AppVMenu v-model="isOpen" :nudge-bottom="40" :close-on-content-click="false">
		<template v-slot:activator="{ on, attrs }">
			<AnemicButton v-on="on" v-bind="attrs" class="more-button pa-0" tile>
				<SIcon name="project-menu-three-dots" class="menu-icon" :width="2" :height="13" />
			</AnemicButton>
		</template>
		<Col class="icons-menu-container overflow-y-auto pa-2">
			<AppTextField outlined single-line hide-details placeholder="Search" v-model="searchString" prepend-inner-icon="mdi-magnify" />
			<Row class="icons-menu-inner-content-container flex-align-center">
				<h3 v-if="showNoResults" class="reg width-100 mt-12 text-align-center">No results</h3>
				<template v-else>
					<NotificationIconButton
						:key="i"
						:icon="icon"
						class="ml-2 mb-2"
						v-on="$listeners"
						@close-menu="isOpen = false"
						v-for="(icon, i) in filteredIcons"
						:isSelected="selectedIcon === icon.name"
					/>
				</template>
			</Row>
		</Col>
	</AppVMenu>
</template>
<script>
import NotificationIconButton from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon/NotificationIcons/NotificationIconButton.vue';
export default {
	name: 'NotificationIconsMenu',
	components: { NotificationIconButton },
	props: {
		selectedIcon: { type: String },
		icons: { type: Array, default: () => [] },
	},
	computed: {
		filteredIcons() {
			return this.icons.filter((icon) => icon.name.toLowerCase().includes(this.searchString.toLowerCase()));
		},
		showNoResults() {
			return this.filteredIcons.length === 0 && this.searchString.length > 0;
		},
	},

	data() {
		return {
			isOpen: false,
			searchString: '',
		};
	},
};
</script>
<style scoped lang="scss">
.more-button {
	width: 35px !important;
	max-height: 35px !important;
	background: white !important;
	border: 1px solid #dcdfe6 !important;
	color: rgba(38, 38, 38, 0.5) !important;
	border-radius: 0px 5px 5px 0px !important;
	border-left: none !important; // order matters
}
.menu-icon {
	margin-top: -2px;
	transform: rotate(90deg);
}
.icons-menu-container {
	width: 340px;
	height: 225px;
	border-radius: 8px;
	background: #ffffff;
	border: 1px solid #e4e8f2;
	box-shadow: 0px 3px 6px #00000046;
}
.icons-menu-inner-content-container {
	display: flex;
	flex-wrap: wrap;
}
</style>
